import { LangType, setCurrentLang } from '@/redux/features/langSlice'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocalStorage } from 'usehooks-ts'
export const langOptions = ['RU', 'EN', 'CN']

import s from './Header.module.scss'
import classNames from 'classnames'
//, 'ZH'

interface HeaderselectProps {
    lightTheme?: boolean
}

const HeaderSelect = ({ lightTheme }: HeaderselectProps) => {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const lang = useSelector((state: any) => state.lang.selected)
    const [localLang, setLocalLang] = useLocalStorage('lang', 'RU')

    const selectRef = useRef<HTMLLIElement>(null)
    const [openSelect, setOpenSelect] = useState(false)
    const [selectedLang, setSelectedLang] = useState(langOptions[0])

    useEffect(() => {
        setSelectedLang(localLang)
        localLang == 'RU' ? changeLanguage(0) : localLang == 'EN' ? changeLanguage(1) : changeLanguage(2)
    }, [])

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (selectRef.current && !event.composedPath().includes(selectRef.current)) {
                setOpenSelect(false)
            }
        }

        document.body.addEventListener('click', handleClickOutside)
        return () => document.body.removeEventListener('click', handleClickOutside)
    }, [])

    const changeLanguage = (index: number, clicked = false) => {
        const langNow = langOptions[index]
        setSelectedLang(langNow)
        let langDispatch: LangType =
            langNow == 'RU' ? { selected: 'RU' } : langNow == 'EN' ? { selected: 'EN' } : { selected: 'CN' }

        setLocalLang(langDispatch.selected)
        dispatch(setCurrentLang(langDispatch))
        i18n.changeLanguage(langNow.slice(0, 2).toLowerCase())
        if (clicked === true && lang !== langNow) {
            location.reload()
        }
        setOpenSelect(false)
    }

    return (
        <li
            ref={selectRef}
            className='header__select'
        >
            <div
                onClick={() => setOpenSelect(!openSelect)}
                className={`header__select-btn header__menu-item ${openSelect && 'header__select-btn_light'} ${
                    lightTheme ? s.lightSelect : ''
                }`}
            >
                <p>{selectedLang}</p>
                <svg
                    className={`header__select-arrow ${openSelect && 'header__select-arrow_rotate'}`}
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M15 12L10.0651 7.77007C10.0276 7.73797 9.97237 7.73797 9.93492 7.77007L5 12'
                        stroke='#919DBD'
                        strokeWidth='2'
                        strokeLinecap='round'
                    />
                </svg>
            </div>
            <div style={{ position: 'relative' }}>
                <ul className={`header__select-list ${openSelect && 'header__select-list_open'}`}>
                    {langOptions?.map((lang, index) => (
                        <li
                            key={index}
                            onClick={() => changeLanguage(index, true)}
                            className={`header__select-option header__menu-item ${
                                selectedLang === lang && 'header__select-option_active'
                            }`}
                        >
                            {lang}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}

export default HeaderSelect
